import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import ar from './locales/ar.json'
import en from './locales/en.json'
import fa from './locales/fa.json'
import fr from './locales/fr.json'
import id from './locales/id.json'
import ms from './locales/ms.json'
import ru from './locales/ru.json'
import vi from './locales/vi.json'

const resources = {
  en: { translation: en },
  ar: { translation: ar },
  fa: { translation: fa },
  fr: { translation: fr },
  id: { translation: id },
  ms: { translation: ms },
  ru: { translation: ru },
  vi: { translation: vi },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'fa', 'fr', 'id', 'ms', 'ru', 'vi'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

export default i18n
